import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'
import { faHeart, faComment } from '@fortawesome/pro-light-svg-icons'
import { faHeart as faSolidHeart } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { i18n } from '@i18n/index'
import { useLanguage } from '@i18n/useLanguage'
import { Style, styled } from 'inlines'

export type PostActivityRowProps = {
  version: 'post' | 'comment' | 'reply'
  hasReaction: boolean
  reactions: number
  comments: number
  onReactionClick: () => void
  onReplyClick: () => void
}

export const PostActivityRow = ({
  version,
  hasReaction,
  reactions,
  comments,
  onReactionClick,
  onReplyClick,
}: PostActivityRowProps) => {
  const [language, _] = useLanguage()
  const translations = i18n.languages[language].app.post
  const containerStyle: Style = {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
    cursor: 'pointer',
  }

  const textStyle: Style = {
    color: 'var(--shades-blue-700)',
    cursor: 'pointer',
    userSelect: 'none',
  }

  return (
    <Row
      gap={version === 'post' ? '1.5rem' : '1rem'}
      style={{
        marginBottom: '0.5rem',
      }}
    >
      <styled.div onClick={onReactionClick} style={containerStyle}>
        <FontAwesomeIcon
          icon={hasReaction ? faSolidHeart : faHeart}
          style={textStyle}
        />
        <Text.Small style={textStyle}>
          {reactions === 0
            ? translations.like
            : `${reactions} ${reactions === 1 ? translations.oneLike : translations.manyLikes}`}
        </Text.Small>
      </styled.div>
      {version !== 'reply' && (
        <styled.div onClick={onReplyClick} style={containerStyle}>
          <FontAwesomeIcon icon={faComment} style={textStyle} />
          <Text.Small style={textStyle}>
            {comments === 0
              ? translations.reply
              : `${comments} ${comments === 1 ? translations.oneReply : translations.manyReplies}`}
          </Text.Small>
        </styled.div>
      )}
    </Row>
  )
}
